import { render, staticRenderFns } from "./SimpleTable.vue?vue&type=template&id=a9adaa86&scoped=true"
import script from "./SimpleTable.vue?vue&type=script&lang=js"
export * from "./SimpleTable.vue?vue&type=script&lang=js"
import style0 from "./SimpleTable.vue?vue&type=style&index=0&id=a9adaa86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9adaa86",
  null
  
)

export default component.exports